<template>
  <div>
    <Row>
      <Form ref="queryConfigForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Form-item :label="this.$t('system.config.name.label')" prop="name">
            <Input v-model="query.name" :placeholder="$t('system.config.name.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('system.config.sign.label')" prop="sign">
            <Input v-model="query.sign" :placeholder="$t('system.config.sign.holder')" style="width: 200px" />
        </Form-item>
        <Form-item :label="this.$t('system.config.type.label')" prop="type">
        <Select v-model="query.type" clearable filterable :placeholder="$t('system.config.type.holder')">
          <Option v-for="item in $t('system.config.type.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openConfigDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="configTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
<!--        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.configTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>-->
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="configDrawer" :title="this.$t('drawer.title')[configDrawer.type]" :visible.sync="configDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <config-form ref="configForm"/>
        <div class="right-drawer__footer" v-if="configDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="configDrawer.submiting">{{ configDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="configDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import ConfigForm from '@/views/system/config/components/Form.vue';
Vue.component('config-form', ConfigForm);

export default {
  name: 'aip-system-config-index',
  mixins:[mixin],
  data () {
    return {
      query:{
          name:''
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      configDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  methods: {
    handleSearch(){
      this.page.loading = true;
      api.system.Config.query(this.query,this.page)
        .then(data=>{
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openConfigDrawer(config){
      this.configDrawer.visible = true
      this.configDrawer.type = config ? config.type : 'add'
      this.$nextTick(()=>{
          if(config){
              this.$refs['configForm'].getConfig(config.id,config.type)
          }else{
            this.$refs['configForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.configDrawer.submiting = true;
        this.$refs.configForm.handleSubmit(
          data=>{
            this.configDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.configDrawer.visible=false, 1000);
          },
          ()=>{
            this.configDrawer.submiting = false;
          }
        )
    },
    deleteConfig(id){
      api.system.Config.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.system.Config.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          /*{key: 'id', width: 60, fixed:'left',type:'selection'},*/

          {key: 'name', align:'center',minWidth: 150,fixed:'left', title:  this.$t('system.config.name.label')},
          {key: 'sign', align:'center',minWidth: 150, title:  this.$t('system.config.sign.label')},
          {key: 'content', align:'center',minWidth: 150, title:  this.$t('system.config.content.label')},
          {
            key: 'type',
            align: 'center',
            width: 120,

            column:'type',
            filters: this.$t('system.config.type.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.type = value
              this.handleSearch();
            },
            title: this.$t('system.config.type.label'),
            render: (h, params) => {
              return  <div>{params.column.filters.find(t=>params.row.type==t.value).label}</div>
            }
          },
          {key: 'remark', align:'center',minWidth: 200, title:  this.$t('system.config.remark.label')},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 180,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openConfigDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openConfigDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteWebSite(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
